<template>
  <section class="score-point">
    <div class="point-heading">
      <strong>{{ item.name || item.itemName || '评分项' }}</strong>
      <span>{{ scoreText(item.score) }} / {{ scoreText(item.maxScore) }} 分</span>
    </div>
    <p v-if="typeof item.completed === 'boolean'" class="point-result">完成情况：{{ item.completed ? '已完成' : '未完成' }}</p>
    <div v-if="item.evidence" class="point-feedback">
      <h4>评分依据</h4><p>{{ item.evidence }}</p>
    </div>
    <div v-if="item.deductionReason" class="point-feedback deduction">
      <h4>扣分原因</h4><p>{{ item.deductionReason }}</p>
    </div>
    <div v-if="suggestions.length" class="point-feedback">
      <h4>提升建议</h4>
      <p v-for="(suggestion, index) in suggestions" :key="index">{{ index + 1 }}. {{ suggestion }}</p>
    </div>
    <p v-if="!item.evidence && !item.deductionReason && !suggestions.length" class="point-empty">本项未记录详细评语</p>
    <el-button v-if="messageIds.length" type="text" size="small" @click="$emit('conversation', messageIds)">查看关联对话</el-button>
    <div v-if="children.length" class="point-children">
      <score-point v-for="(child, index) in children" :key="index" :item="child" @conversation="$emit('conversation', $event)" />
    </div>
  </section>
</template>

<script>
import { scoreText, textSuggestions, toArray } from '@/utils/ai-train-record'

export default {
  name: 'ScorePoint',
  props: { item: { type: Object, required: true } },
  computed: {
    suggestions() { return textSuggestions(this.item.suggestions) },
    messageIds() { return toArray(this.item.messageIds) },
    children() { return toArray(this.item.subItems).filter(item => item && typeof item === 'object') }
  },
  methods: { scoreText }
}
</script>

<style scoped>
.score-point { margin: 12px 0; padding: 16px; border: 1px solid #e4e7ed; border-radius: 6px; background: #fff; }
.point-heading { display: flex; align-items: flex-start; justify-content: space-between; gap: 16px; line-height: 1.7; }
.point-heading strong { min-width: 0; overflow-wrap: anywhere; }
.point-heading span { flex: none; color: #167b70; }
.point-feedback { margin-top: 12px; padding: 10px 12px; background: #f5f9f8; border-radius: 4px; }
.point-feedback h4 { font-size: 13px; margin: 0 0 6px; color: #376d63; }
.point-feedback p, .point-result { margin: 4px 0; white-space: pre-wrap; overflow-wrap: anywhere; line-height: 1.8; }
.deduction { background: #fff6f1; }
.deduction h4 { color: #a85425; }
.point-empty { color: #909399; line-height: 1.8; }
.point-result { color: #606266; font-size: 13px; }
.point-children { margin-top: 12px; }
.point-children .score-point { background: #fafbfc; }
</style>
